import React from 'react';
import * as S from '../sipstyles/SipClient.style';
import { FaDeleteLeft, FaPhone } from 'react-icons/fa6';
import { TbHttpDelete } from 'react-icons/tb';
import MuteComponent from './MuteButton';
import SpeakerModeComponent from './SpeakerModeComponent';
import { CONNECT_NUMBER } from '@/shared/constants';
import { useRecoilValue } from 'recoil';
import { userInfoRecoil } from '@/recoil/atoms/useInfo';

interface KeypadProps {
  phoneNumber: string;
  callStatus: 'idle' | 'dialing' | 'connected' | 'ended' | 'ringing';
  onKeypad: (key: string) => void;
  onDial: () => void;
  onBackspace: () => void;
  onBackspaceAll: () => void;
  onEndCall: () => void;
  onRejectCall: () => void;
  onAcceptCall: () => void;
}

const Keypad = ({
  phoneNumber,
  callStatus,
  onKeypad,
  onDial,
  onBackspace,
  onBackspaceAll,
  onEndCall,
  onRejectCall,
  onAcceptCall,
}: KeypadProps) => {
  const userInfoS = useRecoilValue(userInfoRecoil);

  return (
    <S.KeypadContainer>
      <S.Keypad>
        {['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'].map((key) => (
          <S.Button
            key={key}
            disabled={callStatus !== 'idle'}
            onClick={() => {
              onKeypad(key);
            }}
          >
            {key}
          </S.Button>
        ))}

        {callStatus === 'ringing' ? (
          <>
            <S.EndCallButton onClick={onRejectCall}>
              <FaPhone />
            </S.EndCallButton>
            <S.SwipeCallWrap>
              <S.SwipeCallSpan />
            </S.SwipeCallWrap>
            <S.CallButton className="show" onClick={onAcceptCall}>
              <FaPhone />
            </S.CallButton>
          </>
        ) : (
          <>
            {callStatus === 'connected' ? (
              <SpeakerModeComponent />
            ) : (
              <S.BackspaceButton
                phoneNumber={phoneNumber !== '' && callStatus === 'idle'}
                onClick={onBackspaceAll}
                disabled={phoneNumber === '' || callStatus !== 'idle'}
              >
                <TbHttpDelete />
              </S.BackspaceButton>
            )}

            {(callStatus === 'dialing' || callStatus === 'connected') && (
              <S.EndCallButton onClick={onEndCall}>
                <FaPhone />
              </S.EndCallButton>
            )}
            {callStatus === 'idle' && (
              <S.CallButton onClick={onDial} disabled={!phoneNumber}>
                <FaPhone />
              </S.CallButton>
            )}

            {callStatus === 'connected' ? (
              <MuteComponent />
            ) : (
              <S.BackspaceButton
                phoneNumber={phoneNumber !== '' && callStatus === 'idle'}
                onClick={onBackspace}
                disabled={phoneNumber === '' || callStatus !== 'idle'}
              >
                <FaDeleteLeft />
              </S.BackspaceButton>
            )}
          </>
        )}
      </S.Keypad>
      {CONNECT_NUMBER.has('01024880592') && userInfoS.phnId === '01024880592' && (
        <div
          style={{
            width: '20rem',
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '1rem',
          }}
        >
          <button
            type="button"
            onClick={() => {
              window.fromWebToAppCallStatus(true);
            }}
            style={{ outline: '1px solid ', padding: '1.2rem' }}
          >
            통화시작
          </button>
          <button
            type="button"
            onClick={() => {
              window.fromWebToAppCallStatus(false);
            }}
            style={{ outline: '1px solid ', padding: '1.2rem' }}
          >
            통화종료
          </button>
        </div>
      )}
    </S.KeypadContainer>
  );
};

export default Keypad;
